import { render, staticRenderFns } from "./representation.vue?vue&type=template&id=2f168360&"
import script from "./representation.vue?vue&type=script&lang=js&"
export * from "./representation.vue?vue&type=script&lang=js&"
import style0 from "./representation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports